import { combineReducers } from 'redux';
import deviceReducer from './device';
import logReducer from './log';
import userReducer from './user';

const rootReducer = combineReducers({
  device: deviceReducer,
  log: logReducer,
  user: userReducer
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js